import SelectInput, { DEFAULT_SELECTOR } from 'CoreComponents/selectInput';

document.querySelectorAll(DEFAULT_SELECTOR).forEach(selectInput => {
  new SelectInput(selectInput);
});
